<script setup>
import FormButton from '../Atoms/FormButton.vue'

const props = defineProps({
  icon: {
		type: Object
  },
	title: {
		type: String
	},
	description: {
		type: String
	},
	isActive: {
		type: Boolean,
		default: false,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	onClick: Function,
})

const emit = defineEmits(['click'])

const onSelect = () => {
	if (props.disabled) return
	emit('click')
	props.onClick?.()
}
</script>

<template>
	<FormButton
		:disabled="disabled"
		@click="onSelect"
		:custom-classes="['grid grid-cols-[min-content_1fr] grid-rows-[min-content_1fr] text-left gap-x-3 !p-4 hover:bg-surface-3 w-full disabled:opacity-50 disabled:hover:!bg-transparent', {'bg-main hover:!bg-main-light':isActive && !disabled}]"
	>
		<component class="row-span-2 size-6" :is="props.icon" />
		<h3 class="m-0">{{props.title}}</h3>
		<p class="text-tiny" :class="isActive && !disabled ? 'text-surface-text-2' : 'text-surface-8'">{{ props.description }}</p>
	</FormButton>
</template>
